// src/app/config.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private configUrl = 'assets/config.json';
  private configSettings: any = {};

  constructor(private http: HttpClient) {}

  loadConfigData(): Observable<any> {
    return this.http.get(this.configUrl).pipe(
      map((data) => {
        this.configSettings = data;
      }),
      catchError((error) => {
        console.error('Error in config:', error);
        throw error;
      })
    );
  }


  getConfigData(): any {
    return this.configSettings;
  }
  
}
